import { authService } from "../../utils/authService";
import { logger } from "../../logger-init";
import { store } from "../../store";
import { clearTokens, setIsError } from "../../store/slices/authSlice";

interface HttpResponse {
  status: number;
}

export function errorHandler<T extends HttpResponse>(response: T): T {
  const islogin = authService.isLoggedIn();

  const status = response.status;

  if (islogin && status === 401) {
    logger.warn("Unauthorized access - logging out user", {
      component: "ErrorHandler",
      status: 401,
      correlationId: logger.getCorrelationId(),
    });

    store.dispatch(clearTokens());
    authService.logout().catch((error) => {
      logger.error("Logout failed after 401 error", error, {
        component: "ErrorHandler",
        status: 401,
        correlationId: logger.getCorrelationId(),
      });
    });
  } else if (islogin && status === 403) {
    logger.error("Forbidden access - unauthorized", undefined, {
      component: "ErrorHandler",
      status: 403,
      correlationId: logger.getCorrelationId(),
    });

    store.dispatch(
      setIsError({
        isError: true,
        message: "Unauthorised access",
        code: "403",
      }),
    );
  } else {
    store.dispatch(setIsError(false));
  }

  return response;
}
